import { Research } from './model/units/action';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({  name: 'resPipe', pure: false })
export class ResPipePipe implements PipeTransform {

  transform(value: [Research], args: boolean): any {
    if (!args)
      return value.filter(i => i.unlocked)
    else
      return value.filter(i => i.owned())
  }

}



// WEBPACK FOOTER //
// /Users/zhaolinxu/GitHub/IdleAnt/src/app/res-pipe.pipe.ts